/* @flow */

import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import RadioMenu from 'shared/components/RadioMenu';
import {
  DEFAULT_CONTACT_BLOCKTYPE,
  MAIL_CONTACT_BLOCKTYPE,
  PHONE_CONTACT_BLOCKTYPE,
  MAIL_VALIDATION,
} from './constants';
import RichTextItem from 'shared/components/RichTextItem';
import RichTextCounter from 'shared/components/RichTextCounter';
import { EditorState } from 'draft-js';
import {
  htmlToState,
  linkDecorator,
  stateToHTML,
  getCharCount,
} from 'utils/richtext';
import { CONTACT_CHARACTER_LIMIT } from 'edito/constants/index';

type Props = {
  block: EditorialContactBlock,
  onSerialize?: (block: EditorialMapBlock) => void,
  onCanSubmitChanged?: (value: boolean) => void,
};

const mapBlockContentToEditorState = block =>
  (block.content
    ? htmlToState(block.content)
    : EditorState.createEmpty(linkDecorator));

class Edit extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);

    this.state = {
      editor: mapBlockContentToEditorState(props.block),
    };
  }

  componentDidMount() {
    const { onSerialize, block, onCanSubmitChanged } = this.props;
    if (!block.type) {
      onSerialize({ ...block, type: DEFAULT_CONTACT_BLOCKTYPE });
    }

    if (!block.target) {
      onCanSubmitChanged(false);
    }
  }

  validateContact = (target: String, type: String) => {
    const { editor } = this.state;

    switch (type) {
      case MAIL_CONTACT_BLOCKTYPE:
        return (
          target &&
          MAIL_VALIDATION.test(target) &&
          !(getCharCount(editor) > CONTACT_CHARACTER_LIMIT)
        );
      case PHONE_CONTACT_BLOCKTYPE:
        return (
          target && true && !(getCharCount(editor) > CONTACT_CHARACTER_LIMIT)
        );
      default:
        return false;
    }
  };

  onReceiptChange = (evt: SyntheticEvent) => {
    const { onSerialize, onCanSubmitChanged, block } = this.props;

    if (evt.target instanceof HTMLInputElement) {
      onSerialize({ ...block, target: evt.target.value });
      onCanSubmitChanged(this.validateContact(evt.target.value, block.type));
    }
  };

  onOverlayChange = (evt: SyntheticEvent) => {
    const { onSerialize, block } = this.props;

    if (evt.target instanceof HTMLInputElement) {
      onSerialize({ ...block, text: evt.target.value });
    }
  };

  toggleMail = (evt: SyntheticEvent) => {
    const { onSerialize, block, onCanSubmitChanged } = this.props;
    evt.preventDefault();

    onSerialize({ ...block, type: MAIL_CONTACT_BLOCKTYPE });
    onCanSubmitChanged(
      this.validateContact(block.target, MAIL_CONTACT_BLOCKTYPE)
    );
  };

  togglePhone = (evt: SyntheticEvent) => {
    const { onSerialize, block, onCanSubmitChanged } = this.props;
    evt.preventDefault();

    onSerialize({ ...block, type: PHONE_CONTACT_BLOCKTYPE });
    onCanSubmitChanged(
      this.validateContact(block.target, PHONE_CONTACT_BLOCKTYPE)
    );
  };

  serializeAsHtml = editorState => {
    const { block, onSerialize, onCanSubmitChanged } = this.props;

    this.setState({
      editor: editorState,
    });

    onSerialize({
      ...block,
      content: stateToHTML(editorState.getCurrentContent()),
    });

    onCanSubmitChanged(this.validateContact(block.target, block.type));
  };

  render() {
    const { block } = this.props;
    const { editor } = this.state;

    const typeLabel = block.type === MAIL_CONTACT_BLOCKTYPE
      ? 'Mail'
      : 'Téléphonique';
    const inputType = block.type === MAIL_CONTACT_BLOCKTYPE ? 'email' : 'tel';

    const menuDescriptor = [
      {
        value: MAIL_CONTACT_BLOCKTYPE,
        handler: this.toggleMail,
        label: 'Email',
      },
      {
        value: PHONE_CONTACT_BLOCKTYPE,
        handler: this.togglePhone,
        label: 'Téléphone',
      },
    ];

    return (
      <Form>
        <Form.Field>
          <label>Type de destinataire</label>
          <RadioMenu currentValue={block.type} menuDesc={menuDescriptor} />
        </Form.Field>
        <Form.Input
          label={`Destinataire ${typeLabel}`}
          defaultValue={block.target}
          onChange={this.onReceiptChange}
          type={inputType}
          required
        />
        <Form.Field>
          <label>Description</label>
          <Form.Input
            defaultValue={block.text}
            onChange={this.onOverlayChange}
          />
        </Form.Field>
        <Form.Field>
          <label>Informations supplémentaires</label>
          <RichTextItem
            parentState={editor}
            onChange={this.serializeAsHtml}
            withTextBlocks
            withInlineBasics
            withLinks
            withColors
          />
          <RichTextCounter
            editorState={editor}
            charLimit={CONTACT_CHARACTER_LIMIT}
            chars
          />
        </Form.Field>
      </Form>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/contact/Edit.js